<app-stat-lesson-info [lesson]="lesson" [subject]="subject" [student_class]="student_class"></app-stat-lesson-info>
<div class="second--row">
  <app-stat-menu></app-stat-menu>
  <app-stat-lesson-desc *ngIf="activeUrl !== 'individual' && lesson"
    [lesson]="lesson"
    [avg_amount_speed]="avg_amount_speed"
    [extra_exercise]="extraExercise"
    [currency]="currency"
    [avg_resolve_speed]="avg_resolve_speed">
  </app-stat-lesson-desc>
  <app-stat-lesson-pupil *ngIf='pupil && lesson'
    [pupil]='pupil'
    [lesson]='lesson'
    [individual_data]='individual_data'
    [currency]="currency"
  >
  </app-stat-lesson-pupil>
</div>
